import React from "react";
import Loads from "pages/Loads/Loads";

const LiveTracking: React.FC = () => {
  return (
    <Loads
      readOnly
      breadcrumbLabel="Live Tracking"
      heroTitle={
        <>
          Track flights <span className="text-[#FBBF24] italic">live</span>.
        </>
      }
      heroSubtitle="See real-time status."
    />
  );
};

export default LiveTracking;
